export default __webpack_public_path__ + "static/ak-cached/24h/media/paramount+ with showtime.a5afa38a.png";